import { Injectable, Input } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FormService {

  @Input() preLoadEvent:any;
  public dynamicFormBodyChange = new BehaviorSubject<string>('');
  
  constructor() { }

  public broadDynamicFormChange(body:string){
    this.dynamicFormBodyChange.next(body);
  }
}
